import React from 'react';
import styled from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';

import Box from 'components/elements/Box';
import { DefinitionLabel } from 'styles/base-classes';

const DefinitionLabelText = styled(DefinitionLabel)`
  margin-bottom: 0;
`;

const Text = styled('p')`
  margin: 0;
  font-size: ${modularScale(1)};
  font-weight: 600;
`;

const PlaylistMetadata: React.FC<{ data: any[] }> = (props) => {
  return (
    <Box display="flex" ml="3">
      {props.data.map(
        (
          { name, value }: { name: string; value: number | string },
          i: number
        ) => (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            key={`${name}-${value}`}
            ml={i !== 0 ? 6 : 0}
          >
            <DefinitionLabelText>{name}</DefinitionLabelText>
            <Text>{value}</Text>
          </Box>
        )
      )}
    </Box>
  );
};

export default PlaylistMetadata;
